<template>
  <XField
    :for="formattedLabel"
    :label="parameters.config.label"
    :labelStyle="labelStyle"
    :optional="isOptional"
    :errors="validationErrors(formattedLabel)"
    :errorStyle="formFieldsErrorStyle"
  >
    <XInputDateTime
      :id="formattedLabel"
      :type="parameters.config.options.dateType"
      :data-vv-name="formattedLabel"
      :invalid="validationHasErrors(formattedLabel)"
      v-model="fieldValue"
      :minDatetime="parameters.config.rules.min"
      :maxDatetime="parameters.config.rules.max"
      v-validate="rules"
      @close="onClose"
      @blur="validate"
    />
  </XField>
</template>

<script>
import InputMixin from './InputMixin'
import _ from 'lodash'

export default {
  mixins: [InputMixin],

  computed: {
    formattedLabel () {
      return _.lowerCase(this.parameters.config.label)
    },

    rules () {
      let rules = {
        required: this.parameters.required
      }

      rules.date_iso = {}

      if (this.parameters.config.rules.min) {
        rules.date_iso.min = this.parameters.config.rules.min
      }

      if (this.parameters.config.rules.max) {
        rules.date_iso.max = this.parameters.config.rules.max
      }

      if (Object.keys(rules.date_iso).length === 0) {
        rules.date_iso = true
      }

      return rules
    }
  },

  created () {
    if (this.fieldValue === null) {
      this.fieldValue = ''
    }
  },

  methods: {
    onClose () {
      this.$validator.validate(this.formattedLabel)
    },

    validate () {
      this.$validator.validate(this.formattedLabel)
    }
  }
}
</script>
